import React, { useState } from 'react';
import classes from './style/DepartmentsCard.module.css';
import { IDepartmentsProps, UsersProps } from '../../../types/Departments';
import { nanoid } from 'nanoid';
import { Button } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import EditTitleInput from './EditTitleInput';

interface DepartmentsCardProps {
  department: IDepartmentsProps;
  changeDepartment: (id: number | null, title: string, category_id: number, userId?: number) => {};
  modalSwitch: (id: number | null, title: string, category_id: number) => void;
  category_title: string;
}
const DepartmentsCard = (props: DepartmentsCardProps) => {
  const { department, changeDepartment, modalSwitch, category_title } = props;
  const { category_id, title, users, id } = department;
  const [showEditInput, setShowEditInput] = useState(false);
  const [text, setText] = useState(title);

  const handleChangeText = (value: string) => {
    setText(value);
  };
  // const handlePressEnter = () => {
  //   setShowEditInput(false);
  //   changeDepartment;
  // };
  const showEditInputSwitch = () => {
    setShowEditInput(true);
  };
  return (
    <>
      <div className={classes.WrapperCard}>
        <div className={classes.title}>
          <p>{category_title}</p>
          <div className={classes.titleEdit}>
            <EditTitleInput
              id={id || null}
              category_id={category_id}
              handleChangeText={handleChangeText}
              handleClick={changeDepartment}
              showInput={showEditInput}
              text={text}
              showEditInputSwitch={showEditInputSwitch}
            />
          </div>
        </div>
        <div className={classes.userCount}>Количество сотрудников: {users.length}</div>
        {users.map((user: UsersProps) => {
          const key = nanoid();
          return (
            <div key={key} className={classes.userName}>
              <div className={classes.userText}>{user.name}</div>
              <div className={classes.userHover}>
                {/* <Button >
                      <CrownOutlined />
                    </Button> */}
                <Button
                  className={classes.button}
                  onClick={() => changeDepartment(id, title, category_id, user.id)}
                  style={{ border: 'none' }}
                  size="small"
                >
                  <DeleteOutlined style={{ color: 'red' }} />
                </Button>
              </div>
            </div>
          );
        })}
        <div className={classes.footer}>
          <div className={classes.NumberLessons}></div>
          <div className={classes.ContetnGrup}>
            <Button
              style={{ marginTop: '1em' }}
              type="primary"
              disabled={title === '' && true}
              onClick={() => modalSwitch(id || null, title, category_id)}
            >
              <PlusOutlined />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepartmentsCard;
